<template>
  <div class="base-card is-loading">
    <div class="row-1">
      <div class="tags">
        <div class="tag skeleton"></div>
        <div class="tag skeleton"></div>
      </div>
      <div class="likes-section">
        <Icon name="lucide:thumbs-up" />
        <Icon name="lucide:thumbs-down" />
      </div>
    </div>
    <div class="row-2">
      <div class="image-preview">
        <div class="preview-skeleton skeleton"></div>
      </div>
      <div class="content-section">
        <div class="content-skeleton">
          <div class="title-skeleton skeleton"></div>
          <div class="snippet-skeleton skeleton"></div>
          <div class="meta-skeleton skeleton"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '../../global/scss/mixins/_breakpoints.scss' as bp;

.base-card {
  --color-grey-100: #e0e0e0;
  --color-gray-200: #d3d3d3;
  --color-grey-500: #949494;
  --color-grey-950: #2d2d2d;
  --color-blue-500: #1850c1;
  --color-text-primary: #2d2d2d;
  --color-text-secondary: #474747;
  --color-text-tertiary: var(--color-grey-500);
  --color-purple-500: #662e80;

  border-radius: 4px;
  border: 1px solid var(--color-grey-100);
  padding: 16px;
  text-decoration: none;
  gap: 32px;
  pointer-events: none;

  .row-1 {
    display: flex;
    justify-content: space-between;
  }

  .row-2 {
    display: flex;
  }

  .image-preview {
    display: flex;
    align-items: center;
    margin-right: 16px;
  }

  .content-section {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .likes-section {
    display: flex;
    gap: 12px;
    color: var(--color-grey-500);
  }

  .skeleton {
    background: linear-gradient(90deg, var(--color-grey-100) 25%, var(--color-gray-200) 37%, var(--color-grey-100) 63%);
    background-size: 400% 100%;
    animation: skeleton-loading 1.4s ease infinite;
    border-radius: 4px;
  }

  .preview-skeleton {
    width: 113px;
    aspect-ratio: 4/3;
    @include bp.screen('<=sm') {
      width: 96px;
      height: 72px;
    }
  }

  .content-skeleton {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    .title-skeleton {
      height: 20px;
      width: 70%;
    }

    .snippet-skeleton {
      height: 16px;
      width: 90%;
    }

    .meta-skeleton {
      height: 16px;
      width: 40%;
      margin-top: 4px;
    }
  }

  .tags {
    display: flex;
    gap: 8px;
    font-size: 12px;
    font-weight: 450;
    line-height: 16px;
    letter-spacing: 0.5px;
    text-decoration: none;
    margin-bottom: 12px;
    .tag {
      display: inline-flex;
      padding: 4px 8px;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      background: var(--color-gray-200);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-decoration: none;
      color: var(--color-text-secondary);
      @include bp.screen('<=sm') {
        padding: 2px 7px;
      }
    }
  }
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

@include bp.screen('<=sm') {
  .base-card {
    gap: 16px;
  }

  .tag {
    padding: 2px 7px;
  }
}
</style>
